/* eslint-disable no-console */ const secret =
  "72d29705-33a6-4e70-876a-c3862cfaab56";
// const url = "http://localhost:3000/";
// eslint-disable-next-line prefer-destructuring
const { REACT_APP_APP_BASE_URL: url } = process.env;

// @deprecated
const ApiService = {
  twilioMatchCompleteMessage(matchId, players) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify({ matchId, players, secret }),
    };

    return fetch(`${url}/pub/twilio/matchcompletemessage`, requestOptions);
  },
};

export default ApiService;
